import { motion } from 'framer-motion';

import { useMainMachine } from '../../../utils/useMainMachine';
import { TextSuggestions } from './TextSuggestions';
import { ImageSuggestions } from './ImageSuggestions';
import { ACTIONS } from '../../../state';
import { DisclosureButton } from '../basic-ui/DisclosureButton';

import SparklesIcon from '@crazyegginc/hatch/dist/images/icon-sparkles-filled.svg?react';

export function AISuggestions({ usedVoice, setUsedVoice }) {
  const { useSelector, machine } = useMainMachine();
  const selectedElement = useSelector(({ context }) => context.selectedElement);
  const open = useSelector(({ context }) => context.controlsOpen);

  return (
    <div className="flex flex-col" data-testid="text-controls">
      <div className="h-px bg-gray-600 my-5 -mx-5" />

      <div className="flex items-center justify-between">
        <div className="w-full">
          <button type="button" onClick={() => machine.send({ type: ACTIONS.BACK })}>
            Back
          </button>
        </div>
        <div className="w-full flex justify-center font-semibold whitespace-nowrap items-center">
          <SparklesIcon className="w-4 h-4 fill-current mr-2.5" />
          AI suggestions
        </div>
        <div className="w-full flex justify-end">
          <DisclosureButton
            open={open}
            onClick={() => machine.send({ type: ACTIONS.TOGGLE_CONTROLS })}
            contentId="controls-content"
          />
        </div>
      </div>
      <div className="">
        <motion.div
          initial={false}
          animate={
            open
              ? {
                  height: 'auto',
                  opacity: 1,
                }
              : {
                  height: 0,
                  opacity: 0,
                }
          }
          transition={{ duration: 0.4, ease: 'linear' }}
          className="mt-2.5 flex flex-col"
          id="controls-content"
          data-testid="controls-content"
        >
          {selectedElement.isImage ? (
            <ImageSuggestions usedVoice={usedVoice} setUsedVoice={setUsedVoice} />
          ) : (
            <TextSuggestions usedVoice={usedVoice} setUsedVoice={setUsedVoice} />
          )}
        </motion.div>
      </div>
    </div>
  );
}
